import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import moment from 'moment';
import 'moment/locale/ru';
import { useSelector } from 'react-redux';

import SupplyStatus from '../SupplyStatus';

moment.locale('ru');

const Wrapper = styled('div')`
  padding: 15px;
  margin: 0 -22px;
  position: relative;

  .back-link {
    color: inherit;
    position: absolute;
    font-size: 16px;
    right: 15px;
    top: 15px;
    line-height: 100%;
  }

  .page-title {
    margin: 0 0 5px;
  }

  .header-date {
    margin-bottom: 10px;
  }

  .badges-wrapper {
    display: flex;

    > div {
      padding: 3px 5px;
    }
  }

  .supply-id-edit {
    font-size: 20px;
    display: inline-block;
  }
`;

const MobileHeader = (props) => {
  const currentSupply = useSelector((state) => state.supplies.currentSupply);
  const { supplyCustomId, setSupplyCustomId } = props;

  const [showIdEdit, setShowIdEdit] = useState(false);

  //Если id поставки пустой - это новая поставка
  const pageTitle = currentSupply ? currentSupply.id || 'Новая поставка' : '';

  useEffect(() => {
    if (pageTitle) {
      document.title = pageTitle + ' — Кактус';
    }
  }, [pageTitle]);

  if (!currentSupply) {
    return null;
  }

  const checkRelatedOrders = (items) => {
    return items?.find((item) => item.orderDocId);
  };

  return (
    <Wrapper>
      <h4 className="page-title">
        {pageTitle}
        {!currentSupply.id && !showIdEdit ? (
          <div className="supply-id-edit ml-2">
            <i className="fe-edit" onClick={() => setShowIdEdit(true)}></i>
          </div>
        ) : null}
      </h4>
      {!currentSupply.id && showIdEdit ? (
        <div className="supply-id-edit-input">
          <input
            type="text"
            className="form-control"
            id="id"
            placeholder="№"
            value={supplyCustomId}
            onChange={(e) => setSupplyCustomId(e.target.value)}
          />
        </div>
      ) : null}
      <Link className="back-link" to={'/supplies'}>
        <i className="fe-x" />
      </Link>

      {currentSupply.id ? (
        <>
          <div className="header-date">
            {moment(currentSupply.date).format('DD MMM YYYY HH:mm:SS')}
          </div>
          <div className="badges-wrapper">
            <SupplyStatus
              status={currentSupply.status}
              checkRelatedOrders={checkRelatedOrders(currentSupply.planItems)}
            />
          </div>
        </>
      ) : null}
    </Wrapper>
  );
};

export default MobileHeader;
